import type { PageType } from '@/types/plan'

/** The fixed row title of each page type in a topic's Pages panel. */
export const PAGE_GROUP_LABEL_KEYS: Record<PageType, string> = {
  explainer: 'strategy.pages.groups.explainer',
  offer: 'strategy.pages.groups.offer',
  comparison: 'strategy.pages.groups.comparison',
  'use-case': 'strategy.pages.groups.use-case',
  supporting: 'strategy.pages.groups.supporting',
}

/** The singular name of each page type, as a select option or a label. */
export const PAGE_TYPE_LABEL_KEYS: Record<PageType, string> = {
  explainer: 'strategy.pages.types.explainer',
  offer: 'strategy.pages.types.offer',
  comparison: 'strategy.pages.types.comparison',
  'use-case': 'strategy.pages.types.use-case',
  supporting: 'strategy.pages.types.supporting',
}
